import { useState } from "react";
import type { DayLabeled } from "../../lib/recomputeDays";
import { IcoClose, IcoTrash } from "../../components/icons";
import { ModalBackdrop } from "../../components/ModalBackdrop";

interface Props {
  day: DayLabeled;
  cardCount: number;
  otherDays: DayLabeled[];
  onCancel: () => void;
  onConfirm: (migrateCardsTo: string | null) => void;
}

const cardWord = (n: number) => {
  if (n === 1) return "карточка";
  if (n > 0 && n < 5) return "карточки";
  return "карточек";
};

export function DeleteDayDialog({ day, cardCount, otherDays, onCancel, onConfirm }: Props) {
  const [choice, setChoice] = useState<"migrate" | "delete">("migrate");
  const [targetId, setTargetId] = useState<string>(otherDays[0]?.id ?? "");

  const canMigrate = otherDays.length > 0;

  return (
    <ModalBackdrop onClose={onCancel}>
      <div className="modal modal-narrow" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="launch-dot" style={{ background: "#FEE4E2" }}>
            <IcoTrash size={12} stroke="#DC2626" />
          </div>
          <h2>
            Удалить «{day.weekday}, {day.date}»?
          </h2>
          <div className="spacer" />
          <button type="button" className="modal-close" onClick={onCancel}>
            <IcoClose size={16} />
          </button>
        </div>
        <div className="modal-body">
          <p
            style={{
              margin: "0 0 14px",
              fontSize: 13,
              color: "var(--text-2)",
              lineHeight: 1.5,
            }}
          >
            На этом дне <b>{cardCount}</b> {cardWord(cardCount)}. Что с ними сделать?
          </p>
          {canMigrate && (
            <label className={"typeset-opt" + (choice === "migrate" ? " active" : "")}>
              <input
                type="radio"
                checked={choice === "migrate"}
                onChange={() => setChoice("migrate")}
              />
              <div className="typeset-opt-main">
                <b>Перенести на другой день</b>
                <select
                  className="form-input"
                  style={{ marginTop: 8 }}
                  value={targetId}
                  onChange={(e) => setTargetId(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                >
                  {otherDays.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.weekday}, {d.date} · D{d.dayNum}
                    </option>
                  ))}
                </select>
              </div>
            </label>
          )}
          <label
            className={"typeset-opt" + (choice === "delete" ? " active" : "")}
            style={{ marginTop: canMigrate ? 6 : 0 }}
          >
            <input
              type="radio"
              checked={choice === "delete"}
              onChange={() => setChoice("delete")}
            />
            <div className="typeset-opt-main">
              <b style={{ color: "#DC2626" }}>Удалить вместе с карточками</b>
              <div style={{ fontSize: 11.5, color: "var(--text-3)", marginTop: 2 }}>
                Это действие нельзя отменить
              </div>
            </div>
          </label>
        </div>
        <div className="modal-foot">
          <div className="spacer" />
          <button type="button" className="btn-ghost" onClick={onCancel}>
            Отмена
          </button>
          <button
            type="button"
            className="btn-primary"
            style={{
              background: choice === "delete" ? "#DC2626" : undefined,
              boxShadow:
                choice === "delete" ? "0 1px 2px rgba(220,38,38,0.25)" : undefined,
            }}
            onClick={() => onConfirm(choice === "migrate" ? targetId : null)}
          >
            {choice === "migrate" ? "Перенести и удалить" : "Удалить безвозвратно"}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}
